import React from "react";
import { t } from "i18next";
import { useNavigate } from "react-router-dom";
import { LINK, TilesIds } from "utils/constants/Constants";
import {
  GroupInfoIcon,
  EnrollmentHistoryIcon,
  IdCardIcon,
  ClaimsIcon,
  BillingStatementIcon,
  SupportIcon,
  PasswordHelpIcon,
  Button,
} from "@sentara-health/optimahealth_web";
import { useFeatureFlag } from "../../providers/featureFlag/FeatureFlagProvider";
import { FeatureFlagKey } from "../../providers/featureFlag/FeatureFlagProvider.types";
import {
  BILLING_STATEMENTS,
  ENROLLMENT_HISTORY,
  GROUP_INFORMATION,
  PAY_MONTHLY_INVOICE,
  REQUEST_MEMBER_ID_CARD,
  PASSWORD_HELP,
} from "routes";
import { useBranding, useGlobalState } from "providers";
interface Tile {
  name: string;
  icon: React.JSX.Element;
  id: string;
  route?: string;
  link?: string;
}

export const HomeTiles = () => {
  const { brandConfig } = useBranding();
  const { refreshAccordion } = useGlobalState();
  const navigate = useNavigate();
  const billingStatementsFlag: boolean = useFeatureFlag(
    FeatureFlagKey.BillingStatements
  );
  const tileActions = (tile: Tile) => {
    if (tile.route) {
      navigate(`/app/${tile.route}`);
      refreshAccordion();
    }
    if (tile.link) window.open(tile.link, "_blank");
  };

  const allTiles: Tile[] = [
    {
      id: TilesIds.Title1,
      name: t("nav.tile.groupInformation"),
      icon: <GroupInfoIcon />,
      route: GROUP_INFORMATION,
    },
    {
      id: TilesIds.Title2,
      name: t("nav.tile.enrollmentHistory"),
      icon: <EnrollmentHistoryIcon />,
      route: ENROLLMENT_HISTORY,
    },
    {
      id: TilesIds.Title3,
      name: t("nav.tile.memberIdCard"),
      icon: <IdCardIcon />,
      route: REQUEST_MEMBER_ID_CARD,
    },
    {
      id: TilesIds.Title4,
      name: t("nav.tile.payMonthlyInvoice"),
      icon: <ClaimsIcon />,
      route: PAY_MONTHLY_INVOICE,
    },
    {
      id: TilesIds.Title5,
      name: t("nav.tile.billingStatement"),
      icon: <BillingStatementIcon />,
      route: BILLING_STATEMENTS,
    },
    {
      id: TilesIds.Title6,
      name: t("nav.tile.support"),
      icon: <SupportIcon />,
      link: brandConfig.link.supportTileLink,
    },
    {
      id: TilesIds.Title7,
      name: t("nav.tile.passwordHelp"),
      icon: <PasswordHelpIcon />,
      link: `${PASSWORD_HELP}`,
    },
  ];
  // Filter the allTiles based on the feature flag: BillingStatements
  const filteredTiles = allTiles.filter((item: Tile) => {
    if (item.id === "tile5" && !billingStatementsFlag) {
      return false;
    }
    return true;
  });

  return (
    <>
      {filteredTiles?.length > 0 &&
        filteredTiles.slice(0, 6).map((item: Tile) => {
          return (
            <Button
              onClick={() => tileActions(item)}
              data-testid={`${item.id}`}
              className="grid-col d-flex border_0 flex-column justify-content-center align-items-center bg-transparent home-title-link text-decoration-none"
              key={item.id}
            >
              <span>{item.icon}</span>
              {item.name}
            </Button>
          );
        })}
    </>
  );
};

export default HomeTiles;
